<template>
    <div>
        <div v-if="!pending && licenses.length > 0">
            <div class="text-h6 row items-center q-mb-sm">
                <q-icon name="mdi-select-multiple" size="sm" class="q-mr-xs" />{{ typeText }} {{ upgradeRenewText | toProperCase }} Selection
            </div>

            <p>
                Please select from the list which {{ product.productCategoryID }} {{ typeText | toLowerCase }}(s) to use for {{ upgradeRenewText }}<span v-if="targetEditionText"> to <strong>{{ targetEditionText }}</strong> edition</span>.
            </p>

            <div class="row text-negative text-caption items-center" v-if="showSelectionRequired">
                <q-icon name="mdi-alert-circle" class="text-negative q-pr-xs" style="font-size: 1.25em" /> A {{ typeText }} selection is required
            </div>
            <div class="row wrap">
                <div v-for="license in form.licenses" :key="license.id"
                     class="col-xs-12 col-md-6 col-lg-4" style="border: 1px solid lightgrey; margin-right: -1px; margin-bottom: -1px;">
                    <q-item tag="label" v-ripple @click="showSelectionRequired = false" class="full-height">
                        <q-item-section side top>
                            <q-checkbox :id="license.id" v-model="license.checked" />
                        </q-item-section>

                        <q-item-section top>
                            <q-item-label overline>{{ license.licenseKeyID }}</q-item-label>
                            <q-item-label caption>
                                {{ license.productDescription }}
                            </q-item-label>
                            <q-item-label caption v-if="license.oemName">
                                OEM: {{ license.oemName }}
                            </q-item-label>
                            <q-item-label caption>
                                Expiry: {{ license.expiry | date }}
                            </q-item-label>
                        </q-item-section>

                        <q-item-section side top>
                            <q-badge transparent v-if="getLicenseStatus(license.expiry)" color="positive">
                                Active
                            </q-badge>
                            <q-badge transparent v-else color="negative">
                                Expired
                            </q-badge>
                        </q-item-section>
                    </q-item>
                </div>
            </div>
        </div>
        <div v-if="pending" class="q-pa-xl">
            <q-inner-loading :showing="pending">
                <div>
                    <q-spinner color="primary"
                               :thickness="2"
                               size="3em" />
                </div>
            </q-inner-loading>
        </div>
        <div v-if="!pending && licenses.length <= 0">
            <div class="text-h6 row items-center q-mb-sm">
                <q-icon name="mdi-select-off" size="sm" class="q-mr-xs" />No {{ typeText }} Found
            </div>
            <p>
                A valid {{ product.productCategoryID }} {{ typeText | toLowerCase }} could not be found for {{ upgradeRenewText }}<span v-if="targetEditionText"> to <strong>{{ targetEditionText }}</strong> edition</span>. You can purchase a new {{ typeText | toLowerCase }} on the previous step or at our <router-link :to="{ name:'/store', params: { productLine: product.productCategoryID.toLowerCase() }}">Store</router-link>.
                For further assistance please contact <router-link to="/support/ticket">support</router-link> or call 403.247.8566.
            </p>
        </div>
    </div>
</template>
<script>

    import { cloneDeep } from 'lodash'

    export default {
        name: 'multi-license-selection',
        props: {
            licenses: Array,
            product: Object,
            pending: Boolean,
        },

        data() {
            return {
                form: {
                    licenses: null,
                },
                showSelectionRequired: false,
            }
        },

        methods: {
            syncLicenses() {
                if (this.licenses) {
                    let data = cloneDeep(this.licenses)
                    data.forEach((x) => {
                        x.checked = false;
                    });
                    this.form.licenses = data
                }
            },
            onSubmit() {
                let selectedLicenses = this.form.licenses?.filter(obj => { return obj.checked == true })
                if (!selectedLicenses || selectedLicenses.length < 1) {
                    this.showSelectionRequired = true
                    return
                }
                this.$emit('submitted', selectedLicenses)
            },

        },
        computed: {
            targetEditionText() {
                if (this.product && this.product.isUpgrade)
                    return (this.product.id.includes('MJ8') ? 'MJ8' : 'Professional')
                return ''
            },
            upgradeRenewText() {
                if (this.product) {
                    return (this.product.isUpgrade ? 'upgrade' : 'renewal')
                }
                return 'upgrade or renewal'
            },
            typeText() {
                if (this.product && this.product.isAnnualSubscription)
                    return 'Subscription'
                return 'License'
            }
        },
        created() {
            this.syncLicenses()
        },
        watch: {
            licenses(newVal, oldVal) {
                if (newVal && newVal !== oldVal)
                    this.syncLicenses()
            },
        }

    }
</script>
